import { store } from '../stores/mainStore';


export function handleAppleLogin(id){
	appleLogin(id);
}

window.handleAppleLogin = handleAppleLogin;

function appleLogin(id, token, expiration){
	// window.WrapperApp.postMessage('id: '+id+' token: '+token+' exp '+expiration);
	store.user.apple.update(id);
	store.user.login();
}

export function handleAppleLogout(){
	appleLogout();
}

function appleLogout(){
	store.user.removeAppleId();
}